import { Component, input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-jc-trading-indication',
  standalone: true,
  imports: [MatChipsModule, MatTooltipModule],
  templateUrl: './jc-trading-indication.component.html',
  styleUrl: './jc-trading-indication.component.css',
})
export class JCTradingIndicationComponent {
  showIndication = input<boolean>(false);
}
